// @flow
import GroupByPicker from './GroupByPicker';

export default GroupByPicker;
